export default __webpack_public_path__ + "static/media/otherImg.a79d278a.png";